const state = {
    list: [
        { value: 'Фізична особа', id: 1, key: 'natural' },
        { value: 'Юридична особа', id: 2, key: 'legal' },
        { value: 'Пільговик', id: 3, key: 'beneficiary' },
    ],
};

const getters = {
    CUSTOMER_TYPES: (state, getters, rootState, rootGetters) => {
        const user = (rootGetters && rootGetters.USER) || (getters && getters.USER);

        if (user && user.recipientTypeId == 4) {
            return state.list.filter(item => item.id !== 2);
        }

        return state.list;
    }
};

export default {
    state,
    getters
};

